import { AfterViewInit, Component, Injectable, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './service/auth.service';
import { EventService } from './service/event.service';
import { ShowProgressEvent, ShowLoaderEvent, FormSubmittedEvent } from "./service/events";
import { ErrorStateMatcher } from '@angular/material/core';
import { UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { StyleNonceService } from './inline-styles-csp/style-nonce.service';
import { BroadcastChannelService } from './service/broadcast-channel.service';
import { IntervalSessionService } from './service/interval-session.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
  show: boolean;
  navLinks: string;
  currentUrl: string;
  showNavigation: boolean = true;
  formSubmitted: boolean = false;

  private eventBus: EventService;
  constructor(private _router: Router, eventBus: EventService, private userService: AuthService, private styleNonceService: StyleNonceService
    , private broadcastChannelService: BroadcastChannelService, public intervalSessionService: IntervalSessionService
  ) {
    this.eventBus = eventBus;
  }

  ngAfterViewInit(): void {
    this.styleNonceService.applyNonceToStyles();
  }

  ngOnInit() {

    // Subscribe to the BroadcastChannel messages
    this.broadcastChannelService.onMessage().subscribe((msg: any) => {
      if (msg === 'session-extended') {
        this.intervalSessionService.resumeTimers();
      } else if (msg === 'logout') {
        this.intervalSessionService.closeDialog();
        this._router.navigate(['sessionTimedOut']);
      } else if (msg === 'open-dialog') {
        this.intervalSessionService.openSessionExpireDialog();
      }
    })

    this.styleNonceService.applyNonceToStyles();

    if (self === top) {
      let antiClickjack = document.getElementById("antiClickjack");
      antiClickjack.parentNode.removeChild(antiClickjack);
    } else {
      top.location.href = self.location.href;
    }

    this.show = false;

    this.eventBus.on(
      ShowProgressEvent,
      (event): void => {
        setTimeout(() => {
          this.show = event.payload.show && this.showNavigation;
        });

      }
    );

    this.eventBus.on(
      ShowLoaderEvent,
      (event): void => {
        setTimeout(() => {
          this.showNavigation = event.payload.show;
        });
      }
    );

    this._router.events.subscribe({
      next: (): void => {
        this.currentUrl = this._router.url;
        if (this.userService.getNavLinks()) {
          let navlink = this.userService.getNavLinks().find(e => e.routerLink === this.currentUrl);
          if (navlink) {
            this.navLinks = 'nav-links';
          } else {
            this.navLinks = '';
          }
        }
      }
    });

    this.eventBus.on(
      FormSubmittedEvent,
      (event): void => {
        if (event.payload.text) {
          this.formSubmitted = (event.payload.text == "1");
          if (this.formSubmitted) {
            sessionStorage.setItem('submitFlag', '1'); // For signature pad
          }
        }
      }
    );
  }

  ngOnDestroy() {
    this.eventBus.unsubscribe();
  }
}

@Injectable()
export class CustomErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form?.submitted;
    return (control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
